import { BaseState } from "../..";
import { TransactionMessageFlow, TransactionMessageScope, TransactionMessageType } from "../../../app/data/transaction-monitor/models";


export default interface TransactionDefinitionsState extends BaseState {
    scopes?: TransactionMessageScope[] | null;
    types?: TransactionMessageType[] |  null;
    flows?: TransactionMessageFlow[] | null;
}

export const initialTransactionDefinitionsState: TransactionDefinitionsState = {
    scopes: [],
    loading: false,
    loadingFailed: false,
    loaded: false,
};
